var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","outlined":"","color":"#AAAAAA"}},[_c('lang-flag',{attrs:{"iso":_vm.lang,"squared":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }